import {createContext, useContext} from 'react'

const ContactFormContext = createContext(undefined)
ContactFormContext.displayName = 'ContactFormV2Context'

export const ContactFormContextProvider = ContactFormContext.Provider

export const useContactFormContext = () => {
  const value = useContext(ContactFormContext)

  if (value === undefined) {
    throw new Error('useContactFormContext must be used inside <ContactForm>')
  }

  return value
}
